'use strict';

(function (angular) {

  angular.module('zp').service('MetaTagsService', MetaTagsService);

  /** @ngInject */
  function MetaTagsService(seoMetaConfig) {

    var service = this;

    service.setDefaultTags = setDefaultTags;
    service.setTags = setTags;
    service.setFromState = setFromState;

    var defaultTags = {};
    var tagElements = [];

    ////////////////////////////////////////////

    function setFromState(state, params) {
      if (state && state.data && state.data.meta_type) {
        switch (state.data.meta_type) {
          case 'template':
            setTags(bindStateParamsToTags(params, state.data.meta));
            break;
          case 'data_source':
            setTags(loadTagsContent(state.data.meta_source, state.data.meta));
            break;
          default:
            setTags(state.data.meta);
            break;

        }
      }
    }

    function bindStateParamsToTags(params, tags) {
      var boundedTags = {};
      angular.forEach(tags, function (content, name) {
        var boundedContent = content;
        angular.forEach(params, function (pValue, pName) {
          boundedContent = boundedContent.replace(new RegExp('\\{{' + pName + '\\}}', 'g'), prepareText(pValue));
          var seoMeta = seoMetaConfig.find(function (x) {
            return x.name === pValue;
          });
          if (seoMeta) {
            boundedContent = boundedContent.replace(new RegExp('\\{{' + pName + ':' + name + '\\}}'), prepareText(seoMeta[name]));
          }
        });
        boundedTags[name] = boundedContent;
      });
      return boundedTags;
    }

    function loadTagsContent(source, tags) {
      return tags;
    }

    function setDefaultTags(tags) {
      angular.copy(tags, defaultTags);
      clearHead();
      setTags({});
    }

    function clearHead() {
      angular.forEach(defaultTags, function (content, name) {
        var metaEl = getMetaElementByName(name);
        if (metaEl) {
          document.head.removeChild(metaEl);
        }
      });
    }

    function setTags(tags) {
      clearTags();
      mergeDefaultTags(tags);
      angular.forEach(tags, function (content, name) {
        var tagElement = getTagElement(content, name);
        document.head.appendChild(tagElement);
        tagElements.push(tagElement);
      });
    }

    function mergeDefaultTags(tags) {
      angular.forEach(defaultTags, function (defaultTagContent, defaultTagName) {
        if (!tags[defaultTagName]) {
          tags[defaultTagName] = defaultTagContent;
        }
      });
      return tags;
    }

    function getTagElement(content, name) {
      if (name == 'title') {
        // Special provision for the title element
        var title = document.createElement('title');
        title.textContent = content;
        return title;
      } else {
        // Opengraph uses [property], but everything else uses [name]
        var nameAttr = name.indexOf('og:') === 0 ? 'property' : 'name';
        var meta = document.createElement('meta');
        meta.setAttribute(nameAttr, name);
        meta.setAttribute('content', content);
        return meta;
      }
    }

    function getMetaElementByName(name) {
      if (name === 'title') {
        return document.querySelector('title');
      }
      // var content = (content ===null) ? 'content' : content;
      var nameAttr = name.indexOf('og:') !== -1 ? 'property' : 'name';
      return document.querySelector("meta[" + nameAttr + "='" + name + "']");
    }

    function clearTags() {
      angular.forEach(tagElements, function (tagElement) {
        document.head.removeChild(tagElement);
      });
      tagElements.length = 0;
    }

    function prepareText(text) {
      if (!text) {
        return '';
      }
      text = text.replace(/-/g, ' ');
      text = text.replace(/  +/g, ' ');
      return text.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }
  }
})(window.angular);